// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1TkK3","content":"ManualTimeModal_content__7DGFK"};